import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 3v5l-11 9l-4 4l-3 -3l4 -4l9 -11l5 0","key":"svg-0"}],["path",{"d":"M5 13l6 6","key":"svg-1"}],["path",{"d":"M14.32 17.32l3.68 3.68l3 -3l-3.365 -3.365","key":"svg-2"}],["path",{"d":"M10 5.5l-2 -2.5h-5v5l3 2.5","key":"svg-3"}]]

const IconSwords = createReactComponent('outline', 'swords', 'Swords', __iconNode);

export default IconSwords;